<template>
  <div>
    <CCard class="h-100">
      <CRow>
        <CCol sm="12" class="justify-content-center m-0">
          <CContainer>
            <CCol sm="12" lg="12" class="">
              <h4
                class="text-left mt-4 d-flex d-sm-none text-black bold"
                style="font-size: 24px"
              >
                {{ qSummary.subject }}
              </h4>
              <h5
                class="text-left mt-4 d-flex d-sm-none text-black bold"
                style="font-size: 15px"
              >
                {{ qSummary.grade }}
              </h5>
              <h5
                class="text-left mt-2 d-flex d-sm-none text-black bold"
                style="font-size: 15px"
              >
                {{ qSummary.quizName }}
              </h5>

              <h5
                class="text-left mt-4 d-flex d-sm-none text-black bold"
                style="font-size: 15px"
              >
                <br />
                Question {{ quizNo }}
              </h5>

              <br />

              <CCol>
                <!-- <CTextarea
                  v-model="Question"
                  class="mt-2"
                  placeholder="Question"
                  style="border: 2px solid #009688; border-radius: 10px"
                  vertical
                  rows="5"
                /> -->
                <h6>Enter Your Question</h6>
                <tinymce
                  id="d1"
                  v-model="Question"
                  placeholder="Enter Your Question"
                  class="mb-2"
                ></tinymce>
              </CCol>

              <CCol>
                <CRow>
                  <div class="mt-2">A:</div>
                  <CTextarea
                    v-model="choiceA"
                    class="mr-0 ml-2 col-10 p-0"
                    placeholder
                    style="border: 2px solid #009688; border-radius: 10px"
                    vertical
                    rows="1"
                  />
                </CRow>
              </CCol>

              <CCol>
                <CRow>
                  <p class="mt-2">B:</p>
                  <CTextarea
                    v-model="choiceB"
                    class="mt-0 ml-2 col-10 p-0"
                    placeholder
                    style="border: 2px solid #009688; border-radius: 10px"
                    vertical
                    rows="1"
                  />
                </CRow>
              </CCol>

              <CCol>
                <CRow>
                  <p class="mt-2">C:</p>
                  <CTextarea
                    v-model="choiceC"
                    class="mt-0 ml-2 col-10 p-0"
                    placeholder
                    style="border: 2px solid #009688; border-radius: 10px"
                    vertical
                    rows="1"
                  />
                </CRow>
              </CCol>
              <CCol>
                <CRow>
                  <p class="mt-2">D:</p>
                  <CTextarea
                    v-model="choiceD"
                    class="mt-0 ml-2 col-10 p-0"
                    placeholder
                    style="border: 2px solid #009688; border-radius: 10px"
                    vertical
                    rows="1"
                  />
                </CRow>
              </CCol>
              <CCol>
                <CRow>
                  <p class="mt-2">E:</p>
                  <CTextarea
                    v-model="choiceE"
                    class="mt-0 ml-2 col-10 p-0"
                    placeholder
                    style="border: 2px solid #009688; border-radius: 10px"
                    vertical
                    rows="1"
                  />
                </CRow>
              </CCol>
              <CCol>
                <CRow>
                  <p class="mt-2">F:</p>
                  <CTextarea
                    v-model="choiceF"
                    class="mt-0 ml-2 col-10 p-0"
                    placeholder
                    style="border: 2px solid #009688; border-radius: 10px"
                    vertical
                    rows="1"
                  />
                </CRow>
              </CCol>
              <CCol>
                <CRow>
                  <p class="mt-2">G:</p>
                  <CTextarea
                    v-model="choiceG"
                    class="mt-0 ml-2 col-10 p-0"
                    placeholder
                    style="border: 2px solid #009688; border-radius: 10px"
                    vertical
                    rows="1"
                  />
                </CRow>
              </CCol>
            </CCol>
          </CContainer>
          <CContainer class="id">
            <div class="lines">
              <div class="word">OR</div>
            </div>
            <CCol class="inputbox" style="overflow: hidden">
              <input
                type="file"
                id="app"
                ref="myapp"
                @change="onFileChangeUploadPhoto"
                accept="image/x-png, image/gif, image/jpeg"
              />

              <br />
              <br />
              <div style="max-width: 150%" id="preview">
                <img style="max-width: 60px" v-if="urlApp" :src="urlApp" />
              </div>
            </CCol>
            <br />

            <CCol>
              <h5>Choose the answer</h5>
              <br />
             
            </CCol>
            <CContainer>
            <CRow class="justify-content-center">
              <CCol sm="12" lg="12" class="mt-0" style="display: flex">
                <label>
                  <input
                    type="radio"
                    name="radio"
                    checked
                    v-model="answer"
                    @click="ansId = 1"
                  />
                  <span>A</span>
                </label>

                <label>
                  <input
                    type="radio"
                    name="radio"
                    v-model="answer"
                    @click="ansId = 2"
                  />
                  <span>B</span>
                </label>
              </CCol>

              <CCol sm="12" lg="12" class="mt-4" style="display: flex">
                <label>
                  <input
                    type="radio"
                    name="radio"
                    checked
                    v-model="answer"
                    @click="ansId = 3"
                  />
                  <span>C</span>
                </label>

                <label>
                  <input
                    type="radio"
                    name="radio"
                    v-model="answer"
                    @click="ansId = 4"
                  />
                  <span>D</span>
                </label>
              </CCol>
            </CRow>
            </CContainer>
           

            <CCol sm="12" class="p-0 mb-4">
              <div class="row">
                <CCol class="col-6">
                  <CButton
                    @click="GoToPageList"
                    color="light"
                    class="custom-btn mt-4 text-white"
                    block
                  >
                   <CIcon name="cil-arrow-left" />
                    &nbsp;Back To List
                   
                  </CButton>
                </CCol>
                <CCol class="col-6">
                  <CButton
                    @click="CreateQuestion"
                    color=""
                    class="custom-btn mt-4 text-white"
                    block
                  >
                   <CIcon name="cil-arrow-right" />  &nbsp;New Question
                   
                  </CButton>
                </CCol>
                
              </div>
            </CCol>
             <CCol sm="12">
             <div class="mt-5">
               <h6 class="text-center">To complete this set of question</h6>
              <CButton
                color="success"
                class="custom-btn mt-4 mb-4"
                size="lg"
                block
                :disabled="isDisabled"
                @click="PublishQuiz"
                >Submit</CButton
              >
            </div>
             </CCol>
          </CContainer>
        </CCol>
      </CRow>
    </CCard>
  </div>

  <!--gg  -->
</template>

<script>
import Vue from "vue";
Vue.use(require("vue-moment"));
import vSelect from "vue-select";
import moment from "moment";
import backgroundBanner from "../assets/img/bgApps.jpg";
import _ from "lodash";
import VuejsDialog from "vuejs-dialog";
import "vuejs-dialog/dist/vuejs-dialog.min.css";
import VueTimepicker from "vue2-timepicker";
import "vue2-timepicker/dist/VueTimepicker.css";
Vue.component("v-select", vSelect);
import PulseLoader from "vue-spinner/src/PulseLoader.vue";
import "vue-select/dist/vue-select.css";
import "vue-select/src/scss/vue-select.scss";

import tinymce from "vue-tinymce-editor";
Vue.component("tinymce", tinymce);

// Tell Vue to install the plugin.
Vue.use(VuejsDialog);
export default {
  name: "Login",
  components: {
    PulseLoader,
  },
  data() {
    return {
      backgroundBanner,
      QuestionId: "",
      Question: "",
      choiceA: "",
      choiceB: "",
      choiceC: "",
      choiceD: "",
      choiceE: "",
      choiceF: "",
      choiceG: "",
      ansId: "",
      imageId: "",
      qSummary: {},
      quizNo: "",
      SubmittedForm: false,
      Error: false,
      question: "",
      togglePress: "",
      urlApp: [],
      app: null,

      img1: [],
      urlApp: null,
      files: [],
      urlApp: null,

      data: "",
    };
  },
  async mounted() {
    this.CreateNewQuestion();
    this.GetQuizSummary();
    this.GetQuizNumber();
  },
  computed: {},
  methods: {
    //Get quiz summary
    async GetQuizSummary() {
      return this.$API
        .get(this.$QuizSummary + "?quizId=" + this.$route.query.quizTitleId, {
          withCredentials: true,
        })
        .then((response) => {
          if (response.status == 200 && response.data != null) {
            this.qSummary = response.data;
            console.log(this.qSummary);
          }
        })
        .catch(function (error) {
          console.log(error.response);
        });
    },
    //Get Quiz Nombor
    async GetQuizNumber() {
      this.$API
        .get(
          this.$QuizStartNumber + "?quizId=" + this.$route.query.quizTitleId,
          {
            withCredentials: true,
          }
        )
        .then((response) => {
          if (response.status == 200 && response.data != null) {
            this.quizNo = response.data;
            console.log(this.quizNo);
          }
        })
        .catch(function (error) {
          console.log(error.response);
        });
    },
    async CreateNewQuestion() {
      const formData = new FormData();
      formData.append("userId", this.$route.query.userId);
      formData.append("quizTitleId", this.$route.query.quizTitleId);

      return this.$API
        .post(this.$QuizTeacherNewQuestion, formData, {
          withCredentials: true,
        })
        .then((response) => {
          if (response.status == 200 && response.data != null) {
            this.QuestionId = response.data;
          }
        })
        .catch((error) => {
          if (error.response) {
            this.Busy = false;
            this.Error = true;
            console.log(error.response.status);
            console.log(error.response.data);
          }
        });
    },
    ///insert file photo
    onFileChangeUploadPhoto(e) {
      const file = e.target.files[0];
      this.urlApp = URL.createObjectURL(file);
      this.HandleFileInputPhoto();
    },
    HandleFileInputPhoto() {
      this.photo = this.$refs.myapp.files;
      this.SubmitFilePhoto();
    },
    async SubmitFilePhoto() {
      const formData = new FormData();

      formData.append("file", this.photo[0]);
      formData.append("quizTitleId", this.$route.query.quizTitleId);
      formData.append("questionId", this.QuestionId);

      this.$API
        .post(this.$UploadPhoto, formData, {
          headers: {
            "Content-Type": "multipart/form-data",
          },
        })
        .then((response) => {
          if (response.status == 200 && response.data != null) {
            this.imageId = response.data;
          }
        })
        .catch((error) => {
          console.log("Upload failed.");
          console.log(error);
        });
    },

    ///Insert question detail
    CreateQuestion() {
      this.SubmittedForm = true;
      if (this.Question === "") {
        this.Error = true;
      } else {
        this.Error = false;
        const formData = new FormData();

        var imageId = this.imageId == null ? 0 : this.imageId;
        formData.append("userId", this.$route.query.userId);
        formData.append("ansId", this.ansId);
        formData.append("QuizTitleId", this.$route.query.quizTitleId);
        formData.append("questionId", this.QuestionId);
        formData.append("Question", this.Question);
        formData.append("ChoiceA", this.choiceA);
        formData.append("ChoiceB", this.choiceB);
        formData.append("ChoiceC", this.choiceC);
        formData.append("ChoiceD", this.choiceD);
        formData.append("ChoiceE", this.choiceE);
        formData.append("ChoiceF", this.choiceF);
        formData.append("ChoiceG", this.choiceG);

        console.log("userId", this.$route.query.userId);
        console.log("ansId", this.ansId);
        console.log("questionId", this.QuestionId);
        console.log("ChoiceA", this.choiceA);

        return this.$API
          .post(this.$CreateQuizQuestion, formData, {
            withCredentials: true,
          })
          .then((response) => {
            if (response.status == 200 && response.data != null) {
              this.GoToPageCreateQuestion();
            }
          })
          .catch((error) => {
            if (error.response) {
              this.Busy = false;
              this.Error = true;
              console.log(error.response.status);
              console.log(error.response.data);
            }
          });
      }
    },
    //publish Quiz
    PublishQuiz() {
      if (this.Question !== "") {
        this.CreateQuestion();
      }
      const formData = new FormData();
      formData.append("quizId", this.$route.query.quizTitleId);

      return this.$API
        .post(this.$PublishQuiz, formData, {
          withCredentials: true,
        })
        .then((response) => {
          if (response.status == 200 && response.data != null) {
            this.GoToPageOverview();
          }
        })
        .catch((error) => {
          if (error.response) {
            this.Busy = false;
            this.Error = true;
            console.log(error.response.status);
            console.log(error.response.data);
          }
        });
    },
    GoToPageCreateQuestion() {
      window.location.reload();
    },
    GoToPageOverview() {
      this.$router.push(
        "/QuizTeacherPreview?quizId=" +
          this.$route.query.quizTitleId +
          "&userId=" +
          this.$route.query.userId
      );
    },
    GoToPageList() {
      this.$router.push(
        "/QuizTeacherDraft?quizId=" +
          this.$route.query.quizTitleId +
          "&userId=" +
          this.$route.query.userId
      );
    },
  },
};
</script>

<style>
.lines {
  width: 100%;
  height: 45px;
  position: relative;
}

.lines::after,
.lines::before {
  content: "";
  position: absolute;
  margin: auto;
  height: 2px;
  background: rgb(21, 88, 55);
  width: 45%;
  top: 45%;
}

.lines::after {
  left: 0;
}

.lines::before {
  right: 0;
}

.word {
  height: 50px;
  width: 50px;
  left: 0;
  right: 0;
  top: 0;
  bottom: 0;
  margin: auto;
  text-align: center;
  padding-top: 8px;
  font-size: 15px;
}
.inputbox {
  border: 1px solid black;
  padding-left: 0;
  padding-right: 0;
  padding-top: 10px;
  text-align: center;
  height: 200px;
}
#myfile {
  padding-left: 100px;
  padding-top: 40px;
}

#main:active {
  background-color: #155799;

  color: #f1f2f2;
  box-shadow: none;
}

#main:focus,
.btn:active:focus {
  background-color: #155799;
  box-shadow: 0 12px 16px 0 rgba(0, 0, 0, 0.24),
    0 17px 50px 0 rgba(0, 0, 0, 0.19);

  color: #f1f2f2;
  outline: 0px auto #155799;
}

#main {
  transition: all 0.5s ease-in-out;
}

.form-check:active {
  background-color: #155799;

  color: #f1f2f2;
  box-shadow: none;
}

.form-check:focus,
.btn:active:focus {
  background-color: #155799;
  box-shadow: 0 12px 16px 0 rgba(0, 0, 0, 0.24),
    0 17px 50px 0 rgba(0, 0, 0, 0.19);

  color: #f1f2f2;
  outline: 0px auto #155799;
}

.form-check {
  transition: all 0.5s ease-in-out;
}

.bd:active {
  background-color: #155799;

  color: #f1f2f2;
  box-shadow: none;
}

.bd:focus,
.btn:active:focus {
  background-color: #155799;
  box-shadow: 0 12px 16px 0 rgba(0, 0, 0, 0.24),
    0 17px 50px 0 rgba(0, 0, 0, 0.19);

  color: #f1f2f2;
  outline: 0px auto #155799;
}

.bd {
  transition: all 0.5s ease-in-out;
}

.ba:active {
  background-color: #155799;

  color: #f1f2f2;
  box-shadow: none;
}

.ba:focus,
.btn:active:focus {
  background-color: #155799;
  box-shadow: 0 12px 16px 0 rgba(0, 0, 0, 0.24),
    0 17px 50px 0 rgba(0, 0, 0, 0.19);

  color: #f1f2f2;
  outline: 0px auto #155799;
}

.ba {
  transition: all 0.5s ease-in-out;
}

*:after,
*:before {
  box-sizing: border-box;
}

form {
  display: flex;
  flex-wrap: nowrap;
  flex-direction: row;
}

label {
  display: flex;
  cursor: pointer;
  font-weight: 500;
  position: relative;
  overflow: hidden;
  margin-bottom: 0.375em;
  font-size: calc(1em + 1.25vw);
  color: #000021;
  width: 200px;
  padding-right: 10px;
  padding-left: 30px;
  padding-top: 10px;
  /* Accessible outline */
  /* Remove comment to use */
  /*
      &:focus-within {
          outline: .125em solid $primary-color;
      }
    */
}

label input {
  position: absolute;
  left: -9999px;
}

label input:checked + span {
  background-color: #d6d6e5;
  width: 200px;
}
form {
  display: flex;
  flex-wrap: nowrap;
  flex-direction: row;
}

label {
  display: flex;
  cursor: pointer;
  font-weight: 500;
  position: relative;
  overflow: hidden;
  margin-bottom: 0.375em;
  font-size: calc(1em + 1.25vw);
  color: #000021;
  width: 200px;
  padding-right: 10px;
  padding-left: 30px;
  padding-top: 10px;
  padding-bottom: 10px;

  /* Accessible outline */
  /* Remove comment to use */
  /*
  	&:focus-within {
  			outline: .125em solid $primary-color;
  	}
  */
}
label input {
  position: absolute;
  left: -9999px;
}
label input:checked + span {
  background-color: #d6d6e5;
  width: 200px;
  box-shadow: 0 3px 5px 0 rgba(0, 0, 1, 0.2), 0 3px 5px 0 rgba(0, 0, 0, 0.19);
}
label input:checked + span:before {
  box-shadow: inset 0 0 0 0.4375em #00005c;
}
label span {
  display: flex;
  align-items: center;
  padding: 0.375em 0.75em 0.375em 0.375em;
  border-radius: 99em;
  transition: 0.25s ease;
  border: solid 2px rgb(90, 8, 138);
  width: 200px;
}
label span:hover {
  background-color: #d6d6e5;

  width: 200px;
}
label span:before {
  display: flex;
  flex-shrink: 0;
  content: "";
  background-color: #fff;
  width: 1.5em;
  height: 1.5em;
  border-radius: 50%;
  margin-right: 2.3em;
  transition: 0.25s ease;
  box-shadow: inset 0 0 0 0.125em #00005c;
}

label input:checked + span:before {
  box-shadow: inset 0 0 0 0.4375em #00005c;
}

label span {
  display: flex;
  align-items: center;
  padding: 0.375em 0.75em 0.375em 0.375em;
  border-radius: 99em;
  transition: 0.25s ease;
  border: solid 1px blue;
  width: 200px;
}

label span:hover {
  background-color: #d6d6e5;
  width: 200px;
}

label span:before {
  display: flex;
  flex-shrink: 0;
  content: "";
  background-color: #fff;
  width: 1.5em;
  height: 1.5em;
  border-radius: 50%;
  margin-right: 2.3em;
  transition: 0.25s ease;
  box-shadow: inset 0 0 0 0.125em #00005c;
}

#fb-root{
  display:none;
}
@media only screen and (min-width: 700px) {
  label {
    display: -webkit-box;
    display: -ms-flexbox;
    display: flex;
    cursor: pointer;
    font-weight: 500;
    position: relative;
    overflow: hidden;
    margin-bottom: 0.375em;
    font-size: larger;
    color: #000021;
    width: 235px;
    padding-right: 10px;
    padding-left: 30px;
    padding-top: 10px;
    padding-bottom: 10px;
}
}
</style>
